export const OPEN_CREATE_EVENTSLIST = "OPEN_CREATE_EVENTSLIST";
export const CLOSE_CREATE_EVENTSLIST = "CLOSE_CREATE_EVENTSLIST";
export const SET_SEARCH_TERM = "SET_SEARCH_TERM";
export const SET_EVENTSLIST_PENDING ="SET_EVENTSLIST_PENDING";
export const SET_EVENTSLIST = "SET_EVETLIST";
export const SET_CREATE_NEW_EVENT_SUCCESS = "SET_CREATE_NEW_EVENT_SUCCESS";
export const SET_NEW_EVENT_ID ="SET_NEW_EVENT_ID";
export const SET_ADDED_QUESTIONS_LIST = "SET_ADDED_QUESTIONS_LIST";
export const SET_NEWEVENT_DATA = "SET_NEWEVENT_DATA";
export const SET_QUESTIONS_REDIRECT = "SET_QUESTIONS_REDIRECT";
export const SET_EDIT_QUESTION_DATA="SET_QUESTION_DATA";
export const REDIRECT_TO_ADD_QUESTION = "REDIRECT_TO_ADD_QUESTION";
export const SET_IS_GET_ADDED_QUESTION_LIST_PENDING = "SET_IS_GET_ADDED_QUESTION_LIST_PENDING";
export const SET_IS_GET_EVENT_DATA_PENDING = "SET_IS_GET_EVENT_DATA_PENDING";
export const SET_IS_GET_EDIT_QUESTION_DATA_PENDING = "SET_IS_GET_EDIT_QUESTION_DATA_PENDING";
export const SET_IS_CREATE_NEW_EVENT_PENDING ="SET_IS_CREATE_NEW_EVENT_PENDING";
export const SET_IS_ADD_QUESTION_DATA_PENDING = "SET_IS_ADD_QUESTION_DATA_PENDING";
export const OPEN_ADD_ORGANIZER = "OPEN_ADD_ORGANIZER";
export const CLOSE_ADD_ORGANIZER = "CLOSE_ADD_ORGANIZER";
export const SET_USER_ORGANIZER = "SET_USER_ORGANIZER";
export const SET_ORGANIZER_PENDING = "SET_ORGANIZER_PENDING";
export const SET_ORGANIZER_LIST = "SET_ORGANIZER_LIST";
export const SET_EVENT_ORGANIZER_PENDING = "SET_EVENT_ORGANIZER_PENDING";
export const OPEN_ADD_EVALUATOR = "OPEN_ADD_EVALUATOR";
export const CLOSE_ADD_EVALUATOR = "CLOSE_ADD_EVALUATOR";
export const GET_EVENT_USERS_PENDING = "GET_EVENT_USERS_PENDING";
export const SET_EVENT_USERS = "SET_EVENT_USERS";
export const SET_EVALUATORS_PENDING = "SET_EVALUATORS_PENDING";
export const SET_EVALUATORS_LIST = "SET_EVALUATORS_LIST";
export const SET_USER_EVALUATOR = "SET_USER_EVALUATOR";
export const SET_EVENT_EVALUATORS_PENDING = "SET_EVENT_EVALUATORS_PENDING";
export const SET_DELETE_ORGANIZER_PENDING = "SET_DELETE_ORGANIZER_PENDING";
export const SET_DELETE_EVALUATOR_PENDING = "SET_DELETE_EVALUATOR_PENDING";